import { Grid } from "@mui/material";
import ModalGeneric from "../Generics/ModalGeneric";
import Titulo3 from "../Generics/Titulo3";
import { DadosSolicitacaoPessoal } from "../../model/entities/SolicitacaoPessoal";
import Info from "../Generics/Info";
import dayjs from "dayjs";

type Props = {
  open: boolean;
  onClose: () => void;
  dadosManutencao: DadosSolicitacaoPessoal;
};

const ModalSolicitacaoPessoal: React.FC<Props> = (props) => {
  const { open, onClose, dadosManutencao } = props;

  return (
    <ModalGeneric open={open} onClose={onClose}>
      <Grid container spacing={2}>
        <Grid item md={12} style={{ textAlign: "center" }}>
          <Titulo3>Solicitação Pessoal</Titulo3>
        </Grid>

        <Grid item md={12} xs={12}>
          <Info label={"Motorista"} children={dadosManutencao.nomeMotorista} />
        </Grid>

        <Grid item md={8} xs={12}>
          <Info
            label={"Telefone do Motorista"}
            children={dadosManutencao.telefoneMotorista.replace(
              "whatsapp:+",
              ""
            )}
          />
        </Grid>

        <Grid item md={4} xs={12}>
          <Info
            label={"Origem Motorista"}
            children={dadosManutencao.origemMotorista}
          />
        </Grid>

        <Grid item md={8} xs={12}>
          <Info
            label={"Data da Solicitação"}
            children={dayjs(dadosManutencao.dataHoraSolicitacao).format(
              "DD/MM/YYYY - HH:mm"
            )}
          />
        </Grid>

        <Grid item md={4} xs={12}>
          <Info
            label={"Placa Veículo"}
            children={dadosManutencao.placaVeiculo}
          />
        </Grid>

        <Grid item md={12} xs={12}>
          <Info
            label={"Descrição Solicitação"}
            children={dadosManutencao.descricaoSolicitacao}
          />
        </Grid>

        <Grid item md={6} xs={12}>
          <Info
            label={"E-mail enviado para"}
            children={dadosManutencao.emailDestinatario}
          />
        </Grid>

        <Grid item md={6} xs={12}>
          <Info
            label={"Email enviado com cópia para"}
            children={
              dadosManutencao.emailDestinatarioCopia &&
              dadosManutencao.emailDestinatarioCopia.split(",").map((item) => (
                <>
                  {item.trim()}
                  <br />
                </>
              ))
            }
          />
        </Grid>
      </Grid>
    </ModalGeneric>
  );
};

export default ModalSolicitacaoPessoal;
